import React, { useEffect, useState } from 'react'
import { ClassesDTO } from '../../../interfaces/ClassesDTO'
import styles from './bladeopener.module.css'
import BladeOpenerButton from './BladeOpenerButton';
import { Button } from 'react-bootstrap';
import { useBlade } from '../../../services/BladeProvider';
interface Props {
  classes: ClassesDTO;
  onchangedImt: (inp:ImtStatus) => void;

}
export interface ImtStatus {
  [key: string]: number | null
}

const BladeOpenerButtonRow = ({ classes,onchangedImt }: Props) => {
  const {existsBlade} = useBlade();
  const [status, setStatus] = useState<ImtStatus>({});
  useEffect(() => {
    let st: ImtStatus = {};
    st["0"] = existsBlade(classes.ID,0);
    Object.keys(classes.Level[1].TimePos).map((obj, index) => {
      st[obj] = existsBlade(classes.ID,parseInt(obj));
    });
    setStatus(st);
  }, [classes]);
  useEffect(() => {
    onchangedImt(status);
  },[status])

  const changedButtonStatus =(imtid:string) => {
    console.log(imtid);
    setStatus(prev => {
      let newPre = {...prev};
      if (imtid in prev){
        if (newPre[imtid]){
          newPre[imtid] = null;
        }
        else{
          newPre[imtid] = -1;
        }
      }
      return newPre;
    })
  }
  const deSelectAll = () => {
    changedStateOfAll(null);
  }
  const selectingAll = () => {
    changedStateOfAll(-1);
  }
  const changedStateOfAll = (inp:number | null) => {
    setStatus(prev => {
      let newPre = {...prev};
      Object.keys(newPre).map((obj) => {
        newPre[obj] = inp;
        return newPre;
      })
      return newPre;
    })
  }
  return (
    <div className={styles.class_box}>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="basic-addon1">{classes.Name}</span>
        </div>
        <Button onClick={selectingAll} className={styles.button} variant='light'>Select all</Button>
        <Button onClick={deSelectAll} className={styles.button} variant='light'>Deselect all</Button>
        {/* <Button onClick={selectingAll} className={styles.button + " " + styles.button_confirm}> {'\u00A0'}</Button>
        <Button onClick={deSelectAll} className={styles.button + " " + styles.button_cancel}>{'\u00A0'}</Button> */}
      </div>
      <div className={"btn-group btn-group-sm " + styles.class_button_group} role="group" aria-label="...">
        <BladeOpenerButton vtype={null} isactive={status["0"]} changedState={() => changedButtonStatus("0")} intermediatepoint={null} />
        {Object.keys(classes.Level[1].TimePos).map((obj, index) => (
          <BladeOpenerButton vtype={null} key={obj} isactive={status[obj]} changedState={() => changedButtonStatus(obj)} intermediatepoint={classes.Level[1].TimePos[parseInt(obj)]} />
        ))}
      </div>
    </div>
  )
}

export default BladeOpenerButtonRow